export default "__VITE_ASSET__DEaN_iFh__"